export const TEXT_MARKER_ANCHOR_SESSION_KEY = 'ui/text/anchorPlayhead'

const finiteNumber = (value, fallback = 0) => {
  const next = Number(value)
  return Number.isFinite(next) ? next : fallback
}

export const getTextLineEntries = (text = '') => {
  const source = `${text || ''}`
  const entries = []
  const re = /([^\r\n]*)(\r\n|\r|\n|$)/g
  let match = re.exec(source)

  while (match) {
    const raw = `${match[1] || ''}`
    const newline = `${match[2] || ''}`
    if (!raw && !newline && match.index >= source.length) break

    const trimmed = raw.trim()
    if (trimmed) {
      const leading = raw.length - raw.trimStart().length
      entries.push({
        index: entries.length,
        raw,
        text: trimmed,
        start: match.index + leading,
        length: trimmed.length,
      })
    }

    if (!newline) break
    match = re.exec(source)
  }

  return entries
}

export const getTextLines = (text = '') => getTextLineEntries(text).map((line) => line.text)

export const resolveCameraStrip = (projectState = {}) => {
  const tracks = projectState.tracks || {}
  const cameraStripUuid = projectState.cameraStrip
  if (!cameraStripUuid) return { trackUuid: null, strip: null }

  const trackUuid = Object.keys(tracks).find((tuuid) => {
    return !!tracks[tuuid]?.strips?.[cameraStripUuid]
  })

  return {
    trackUuid: trackUuid || null,
    strip: trackUuid ? tracks[trackUuid]?.strips?.[cameraStripUuid] || null : null,
  }
}

export const getTextCameraMarkers = (projectState = {}, anchorTime = 0) => {
  const { strip } = resolveCameraStrip(projectState)
  if (!strip) return []

  const anchor = finiteNumber(anchorTime, 0)
  const stripStart = finiteNumber(strip.start, 0)
  const keyframes = Array.isArray(strip.animation?.keyframes)
    ? strip.animation.keyframes
    : []

  return keyframes
    .filter((kf) => !!(kf && kf.marker))
    .map((kf) => ({
      uuid: kf.uuid,
      keyframe: kf,
      timeAbs: stripStart + finiteNumber(kf.time, 0),
    }))
    .filter((marker) => marker.timeAbs >= anchor - 1e-6)
    .sort((a, b) => a.timeAbs - b.timeAbs)
}

export const getTextMarkerLineIndex = (projectState = {}, markerUuid, anchorTime = 0) => {
  if (!markerUuid) return -1
  return getTextCameraMarkers(projectState, anchorTime).findIndex(
    (marker) => marker.uuid === markerUuid
  )
}
